import { useAuthenticatedSWR } from '../api';
import { SUBSCRIPTIONS_V3_BASE_URL } from './constants';

export const useSubscriptions = (legacy = true) => {
  const { data, error } = useAuthenticatedSWR(
    !!legacy ? SUBSCRIPTIONS_V3_BASE_URL : null,
  );

  return {
    isLoading: !legacy ? false : !error && !data?.data,
    isError: error,
    subscriptions: data?.data,
  };
};
